<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <v-container v-if="!loading && items.length" class="py-6 py-md-10">
        <TitleWidget class="text-center">Imóveis Relacionados</TitleWidget>

        <div v-if="items.length" class="mt-6 mt-md-8 justify-center grid-list">
          <template v-for="(item, keyItems) in items">
            <div :key="keyItems" class="grid-list-item">
              <PropertyCard v-bind="item" />
            </div>
          </template>
        </div>
      </v-container>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import PropertyCard from "../cards/PropertyCard.vue";
import { formatToURL } from "../../utils/formatToURL";

const _config = {
  mod: "properties",
  path: "/imoveis",
  itemsPerPage: 7,
};

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    district: {
      type: Number,
      required: true,
    },
    business: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    loading: true,
    items: [],
  }),
  created() {
    this.getList();
  },
  computed: {
    path() {
      return this.business === 1 ? "/alugar" : "/comprar";
    },
  },
  methods: {
    getList() {
      this.loading = true;

      const params = {
        itemsPerPage: _config.itemsPerPage,
      };

      if (this.district) params.district = this.district;
      if (this.business) params.business = this.business;

      this.$rest(_config.mod)
        .get({ params })
        .then((data) => {
          this.items = data
            .filter(({ id }) => Number(this.id) !== id)
            .map(
              ({
                id,
                img,
                title,
                category,
                price,
                reference,
                district,
                garage,
                bedrooms,
                suites,
                area,
                total_area,
              }) => ({
                img,
                title,
                category,
                price,
                reference,
                district,
                details: [
                  {
                    icon: "fas fa-bed",
                    text:
                      (Number(bedrooms) > 0 ? Number(bedrooms) : 0) +
                      (Number(suites) > 0 ? Number(suites) : 0),
                  },
                  {
                    icon: "fas fa-car",
                    text: Number(garage) > 0 ? Number(garage) : 0,
                  },
                  {
                    icon: "fas fa-home",
                    text: parseFloat(area) > 0 ? `${area}m²` : 0,
                  },
                  {
                    icon: "fas fa-expand-arrows-alt",
                    text: parseFloat(total_area) > 0 ? `${total_area}m²` : 0,
                  },
                ],
                to: this.path + `/${formatToURL(title)}-${id}`,
              })
            );

          if (this.items.length === _config.itemsPerPage) this.items.pop();
        })
        .then(() => (this.loading = false));
    },
  },
  watch: {
    $route() {
      this.getList();
    },
  },
  components: {
    LoadingWidget,
    TitleWidget,
    PropertyCard,
  },
};
</script>

<style lang="scss" scoped>
.grid-list {
  display: grid;
  gap: 30px;
  grid-template-columns: repeat(3, 1fr);

  @media screen and (max-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
}
</style>
